import { atom } from "recoil";
import SaleVoModel from "../Models/SaleVoModel";
export const SaleVoState = atom({
  key: "SaleVoState",
  default: new SaleVoModel(),
});
